import { FULL_HD, HD, safetyMargins } from '@bedrock-rdk/constants';
import { FONT, getFont } from '@tornado-rdk/typography';
import { makeThemeColor, PRIMARY, TERTIARY } from '@tornado-rdk/theme';
import { Lightning } from '@lightningjs/sdk';
import { makeDefaultStylingContext } from '../tornado/utils/style';
import { SCREEN_WIDTH, SCREEN_HEIGHT, middle } from '../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const COVER_SIZE = {
  [HD]: 256,
  [FULL_HD]: 440,
};

export const SPINNER_SIZE = {
  [HD]: 200,
  [FULL_HD]: 200,
};

export const colors = {
  text: makeThemeColor(PRIMARY),
  shadow: makeThemeColor(TERTIARY),
  background: makeThemeColor(TERTIARY),
};

export const TEXT_SHADOW_OFFSET_X = 0;

export const TEXT_SHADOW_OFFSET_Y = 2;

export const IMAGE_MARGIN = {
  [HD]: 16,
  [FULL_HD]: 24,
};

export const TEXT_MARGIN = {
  [HD]: 4,
  [FULL_HD]: 4,
};

export const IMAGE_INITIAL_ALPHA = 0.0001;

export const getTitleFont = screenSize => getFont(FONT.PARIS_3, screenSize);

export const getExtraTitleFont = screenSize => getFont(FONT.KINSHASA_1, screenSize);

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const w = SCREEN_WIDTH[screenSize];
  const h = SCREEN_HEIGHT[screenSize];
  const coverSize = COVER_SIZE[screenSize];
  const middleX = Math.round(w / 2);
  const middleY = Math.round(h / 2);
  const coverMiddle = Math.round(coverSize / 2);

  const commonTextConfig = {
    textColor: colors.text[colorMode],
    shadow: true,
    shadowColor: colors.shadow[colorMode],
    shadowOffsetX: TEXT_SHADOW_OFFSET_X,
    shadowOffsetY: TEXT_SHADOW_OFFSET_Y,
    textAlign: 'center',
    maxLines: 1,
    maxLinesSuffix: '...',
    verticalAlign: 'middle',
  };

  return {
    w,
    h,
    Background: {
      w,
      h,
      colorTop: colors.background[colorMode],
      colorBottom: colors.background[colorMode],
    },
    Content: {
      w: coverSize,
      h: coverSize,
      x: middleX,
      y: middleY,
      mount: 0.5,
      Cover: {
        alpha: IMAGE_INITIAL_ALPHA,
        w: coverSize,
        h: coverSize,
        Shadow: {
          amount: 3,
          mount: 0.5,
          w: coverSize * 2,
          h: coverSize * 2,
          x: coverMiddle,
          y: coverMiddle,
          content: {
            rect: true,
            color: 0x2f000000,
            x: coverMiddle,
            y: coverMiddle + 16,
            w: coverSize + 8,
            h: coverSize + 8,
            shader: {
              type: Lightning.shaders.RoundedRectangle,
              radius: 8,
            },
          },
        },
        Image: {
          w: coverSize,
          h: coverSize,
          shader: {
            radius: 8,
          },
        },
      },
      Title: {
        mountX: 0.5,
        x: middle,
        w: w - safetyMargins.horizontal[screenSize] * 2,
        font: {
          ...getTitleFont(screenSize),
          ...commonTextConfig,
        },
      },
      ExtraTitle: {
        mountX: 0.5,
        x: middle,
        w: w - safetyMargins.horizontal[screenSize] * 2,
        font: {
          ...getExtraTitleFont(screenSize),
          ...commonTextConfig,
        },
      },
    },
    Controls: {},
    Spinner: {
      alpha: 0,
      mount: 0.5,
      w: SPINNER_SIZE[screenSize],
      h: SPINNER_SIZE[screenSize],
      x: middle,
      y: middle,
    },
  };
};

export const getControlsVisibleStyle = screenSize => ({
  Content: {
    smooth: {
      y: Math.round(SCREEN_HEIGHT[screenSize] / 2),
    },
    Title: {
      smooth: {
        alpha: 1,
      },
    },
    ExtraTitle: {
      smooth: {
        alpha: 1,
      },
    },
  },
});

export const getControlsHiddenStyle = (screenSize, coverOffset) => ({
  Content: {
    smooth: {
      y: Math.round(SCREEN_HEIGHT[screenSize] / 2) + (coverOffset || 0),
    },
    Title: {
      smooth: {
        alpha: 0,
      },
    },
    ExtraTitle: {
      smooth: {
        alpha: 0,
      },
    },
  },
});
